import { InputAdornment, SxProps, TextField } from '@mui/material';
import { useField } from 'formik';
import { HTMLAttributes, HTMLInputTypeAttribute, ReactNode } from 'react';

export interface FormikTextFieldProps {
  name: string;
  label: string;
  helperText?: string;
  errorText?: string;
  type: HTMLInputTypeAttribute;
  endAdornment?: ReactNode;
  startAdornment?: ReactNode;
  required?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  autoComplete?: string;
  onActive?: (active: boolean) => void;
  inputMode?: HTMLAttributes<HTMLInputElement>['inputMode'];
  sx?: SxProps;
  testId?: string;
}

export const FormikTextField = (props: FormikTextFieldProps) => {
  const [field, meta] = useField(props.name);
  const hasError = meta.touched && Boolean(meta.error);
  const helperText = hasError
    ? (props.errorText ?? props.helperText)
    : props.helperText;

  return (
    <TextField
      id={props.name}
      aria-label={props.name}
      name={props.name}
      label={props.label}
      type={props.type}
      required={props.required}
      fullWidth={props.fullWidth ?? true}
      value={field.value}
      onChange={field.onChange}
      onBlur={(e) => {
        field.onBlur(e);
        if (props.onActive) props?.onActive(false);
      }}
      onFocus={() => {
        if (props.onActive) props.onActive(true);
      }}
      error={hasError}
      helperText={helperText}
      disabled={props.disabled}
      autoComplete={props.autoComplete ?? 'off'}
      sx={props.sx}
      slotProps={{
        htmlInput: {
          inputMode: props.inputMode ?? 'text',
        },
        input: {
          inputProps: {
            'data-testid': props.testId,
          },
          startAdornment: props.startAdornment ? (
            <InputAdornment position="start">
              {props.startAdornment}
            </InputAdornment>
          ) : undefined,
          endAdornment: props.endAdornment ? (
            <InputAdornment position="end">{props.endAdornment}</InputAdornment>
          ) : undefined,
        },
      }}
    />
  );
};
